// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest, getNoBaseRequest } from '@/libs/axios';


// 分页获取
export const _getByPage = (params) => {
    return postRequest('/pre/getByPage', params)
};

// 获取预登记详情信息
export const _getDetail = (params) => {
    return getRequest('/pre/getDetail', params)
};

//预登记
export const _save = (params) => {
    return postRequest('/pre/save', params)
};
//重新提交
export const _resubmit = (params) =>{
    return postRequest('/pre/save',params)
}

export const _updateUrgentDayType = (params) =>{
    return postRequest('/pre/updateUrgentDayType',params)
}

//作品类型
export const _getWorksTypeCopyright = (params) => {
    return getNoBaseRequest('/bqjvip/config/getWorksTypeList2', params)
}